import { createAction } from 'redux-actions'
import * as constants from './constants'

export const presenceDiff = createAction(constants.PRESENCE_DIFF)
export const presenceDiffLeaves = createAction(constants.PRESENCE_DIFF_LEAVES)

export const sendWelcomeMessage = createAction(constants.SEND_WELCOME_MESSAGE)
export const sendWelcomeMessageSuccess = createAction(constants.SEND_WELCOME_MESSAGE_SUCCESS)
export const sendWelcomeMessageFailure = createAction(constants.SEND_WELCOME_MESSAGE_FAILURE)

export const setFilters = createAction(constants.SET_FILTERS)
export const setNewFilters = createAction(constants.SET_NEW_FILTERS)
export const setNewSorts = createAction(constants.SET_NEW_SORTS)
export const setFilterKnownUsers = createAction(constants.SET_FILTER_KNOWN_USERS)
export const setPagination = createAction(constants.SET_PAGINATION)
export const setCustomInterval = createAction(constants.SET_CUSTOM_INTERVAL)

export const setShowMore = createAction(constants.SET_SHOW_MORE)

export const initializePresenceForUsers = createAction(constants.INITIALIZE_PRESENCE_FOR_USERS)
export const setPresenceIsReceiving = createAction(constants.SET_PRESENCE_IS_RECEIVING)

export const bootstrapUser = createAction(constants.BOOTSTRAP_USER)
export const bootstrapUserSuccess = createAction(constants.BOOTSTRAP_USER_SUCCESS)
export const bootstrapUserError = createAction(constants.BOOTSTRAP_USER_ERROR)

export const setBufferedUsers = createAction(constants.SET_BUFFERED_USERS)

export const setProcessAllUsers = createAction(constants.SET_PROCESS_ALL_USERS)
export const addUserProcessed = createAction(constants.ADD_USER_PROCESSED)
export const removeUserProcessed = createAction(constants.REMOVE_USER_PROCESSED)
export const removeUserProcessedDelayed = createAction(constants.REMOVE_USER_PROCESSED_DELAYED)

export const sendActiveStatus = createAction(constants.SEND_ACTIVE_STATUS)
export const setPresenceProblems = createAction(constants.SET_PRESENCE_PROBLEMS)
export const setPresenceLoading = createAction(constants.SET_PRESENCE_LOADING)

export const setNewLiveUsers = createAction(constants.SET_NEW_LIVE_USERS)

export const getPresenceStateOnInterval = createAction(constants.GET_PRESENCE_STATE_ON_INTERVAL)
export const cancelPresenceInterval = createAction(constants.CANCEL_PRESENCE_INTERVAL)

export const setHasProcessedUsers = createAction(constants.SET_HAS_PROCESSED_USERS)
export const messageSent = createAction(constants.MESSAGE_SENT)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/presence/actions.js